<template lang="pug">
  button.notifications.row.middle.center.m-right-2(@click='toggleNotifications')
    simple-svg.white-icon(v-if='!hasNotifications' :filepath='notificationIcon' width='18px' height='18px')
    simple-svg.white-icon(v-else :filepath='notificationActiveIcon' width='18px' height='18px')
</template>

<script>
import { mapActions, mapState } from 'vuex'
import notificationIcon from '@/assets/ic_notification.svg'
import notificationActiveIcon from '@/assets/ic_notification-active.svg'
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr'

export default {
  data() {
    return {
      notificationIcon,
      notificationActiveIcon,
      hasNotifications: false,
      notificationsHub: null
    }
  },
  async created() {
    this.notificationsHub = new HubConnectionBuilder()
      .configureLogging(process.env.NODE_ENV === 'development' ? LogLevel.Debug : LogLevel.None)
      .withUrl(`${process.env.VUE_APP_API_BASE_URL}/notificationHub`)
      .build()

    this.notificationsHub.on('NewNotification', (hasNotifications) => {
      this.hasNotifications = hasNotifications
    })
    this.notificationsHub.on('UpdatedNotifications', this.searchNotifications)
    await this.notificationsHub.start()
    await this.searchNotifications()
  },
  beforeDestroy() {
    this.notificationsHub.stop()
  },
  computed: {
    ...mapState({
      showNotificationsDrawer: state => state.behavior.notificationsDrawer.show,
      userInfo: state => state.userInfo.userInfo,
      notifications: state => state.notifications.notifications.notifications
    })
  },
  methods: {
    ...mapActions([
      'showElement',
      'hideElement'
    ]),
    async searchNotifications() {
      await this.notificationsHub.invoke('SearchNotifications', this.userInfo.userId)
    },
    toggleNotifications() {
      if (this.showNotificationsDrawer) this.hideElement({ element: 'notificationsDrawer' })
      else {
        this.showElement({ element: 'notificationsDrawer' })
        this.hasNotifications = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.notifications{
  background-color: $black;
  border-radius: 15px;
  width: 45px;
  height: 30px;
  position: relative;
}
</style>
